import { ReadonlyURLSearchParams } from 'next/navigation';
import { getAbsoluteUrl } from '@/lib/utils/getAbsoluteUrl';

export function matchPathname(
  currentPath: string,
  linkPath: string,
  exact: boolean = false,
): boolean {
  return exact ? currentPath === linkPath : currentPath.startsWith(linkPath);
}

export function matchQuery(
  current: ReadonlyURLSearchParams,
  linkParams: URLSearchParams,
  exact: boolean = false,
): boolean {
  const linkEntries = Array.from(linkParams.entries());
  // every param in link must match current
  if (!linkEntries.every(([k, v]) => current.get(k) === v)) {
    return false;
  }
  // if exact, also ensure current doesn’t have extra keys
  if (exact) {
    const currentKeys = Array.from(current.keys());
    const linkKeys = linkEntries.map(([k]) => k);
    return currentKeys.length === linkKeys.length;
  }
  return true;
}

type MatchRouteUrlOptions = {
  currentPathname: string;
  currentSearchParams: ReadonlyURLSearchParams;
  linkHref: string;
  exact?: boolean;
  compareSearchParams?: boolean;
};

export function matchRouteUrl({
  currentPathname,
  currentSearchParams,
  linkHref,
  exact = false,
  compareSearchParams = false,
}: MatchRouteUrlOptions): boolean {
  const url = getAbsoluteUrl(linkHref);
  const pathMatches = matchPathname(currentPathname, url.pathname, exact);
  const searchParamsMatches = compareSearchParams
    ? matchQuery(currentSearchParams, url.searchParams, exact)
    : true;

  return pathMatches && searchParamsMatches;
}
